/**
 * Terms & conditions status of intermediary business config's agent
 * @type {{UNTOUCHED: string, ACCEPTED: string, DENIED: string}}
 */
const AcceptedTermsConditions = {
  UNTOUCHED: 'UNTOUCHED',
  ACCEPTED: 'ACCEPTED',
  DENIED: 'DENIED',
};

export { AcceptedTermsConditions };
